import {useEffect, useState} from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import {AppContent, ContentRow} from '../../../styled/components';
import {ActionsRow, ContentRowHeader, CountryContainer, FormRow} from './country-form.styles';
import {getCountry} from '../api-service';

const Field = ({label, value}) => (
  <Box sx={{flex: 1, minWidth: 200}}>
    <Typography
      variant="caption"
      color="textSecondary"
      sx={{display: 'block', textTransform: 'uppercase', letterSpacing: 0.4}}
    >
      {label}
    </Typography>
    <Typography variant="body1" sx={{wordBreak: 'break-word'}}>
      {value && String(value).trim() !== '' ? value : '—'}
    </Typography>
  </Box>
);

function CountryShow({countryId, onEdit, onList}) {
  const [country, setCountry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getCountry(countryId)
      .then((data) => {
        if (!data) {
          throw new Error(`Country ${countryId} not found`);
        }
        setCountry(data);
      })
      .catch((err) => setError(err.message || 'Error loading country'))
      .finally(() => setLoading(false));
  }, [countryId]);

  if (loading) {
    return (
      <AppContent>
        <ContentRow>
          <Typography variant="h5" component="h1">Loading country...</Typography>
        </ContentRow>
      </AppContent>
    );
  }

  if (error || !country) {
    return (
      <AppContent>
        <ContentRow>
          <Typography variant="h5" component="h1" color="error">
            {error || 'Country not found'}
          </Typography>
        </ContentRow>
      </AppContent>
    );
  }

  const states = country.states || [];

  return (
    <AppContent>
      <ContentRow sx={ContentRowHeader}>
        <Typography variant="h5" component="h1">{`Countries / ${country.name || ''}`}</Typography>
        <Box sx={ActionsRow}>
          <Button variant="outlined" onClick={onList}>Countries list</Button>
          <Button variant="contained" onClick={onEdit}>Edit</Button>
        </Box>
      </ContentRow>
      <ContentRow>
        <Box sx={CountryContainer}>
          <Box sx={FormRow}>
            <Field label="Country Name" value={country.name}/>
            <Field label="Country Code" value={country.code}/>
          </Box>
          <Box sx={FormRow}>
            <Field label="Currency" value={country.currency}/>
            <Field label="Country Calling Code" value={country.phoneCode}/>
            <Field label="VAT Label" value={country.vatLabel}/>
          </Box>
        </Box>
      </ContentRow>

      {states.length > 0 && (
        <ContentRow>
          <Box sx={{width: '100%'}}>
            <Typography variant="h6" sx={{marginBottom: 1}}>States</Typography>
            <TableContainer component={Paper}>
              <Table aria-label="states table">
                <TableHead>
                  <TableRow>
                    <TableCell>State Name</TableCell>
                    <TableCell>State Code</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {states.map((state) => (
                    <TableRow key={`state-${state.id}`}>
                      <TableCell>{state.name}</TableCell>
                      <TableCell>{state.code || ''}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </ContentRow>
      )}
    </AppContent>
  );
}

export default CountryShow;
